export default {
  title: 'Signaturvorschau',
  setupInstruction: `
    <h3>Grundlegende Anwendung:</h3>
    <p>Klicken Sie auf die Schaltfläche "Als HTML kopieren" und fügen Sie einen Ausschnitt Ihrer Signatur in die Einstellungen Ihres E-Mail-Clients ein.</p>
    <h3>Vorzeitige Nutzung:</h3>
    <p>Für einige E-Mail-Clients, wie z.B. gmail, können Sie die Markierungsauswahl einfach kopieren und einfügen. Klicken Sie auf die Schaltfläche "Als Auswahl kopieren" und fügen Sie Ihre Signatur in die Einstellungen Ihres E-Mail-Clients ein.</p>
  `,
  viewSource: {
    title: 'Ihre E-Mail-Signatur',
    description: 'Kopiere den untenstehenden HTML-Code und füge ihn in deine'
  },
  moreTemplate: 'Bald mehr Templates',
  selectTemplate: 'Vorlage auswählen'
};
